import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Eye, Mail, Star, TrendingUp } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid } from "recharts";

export default function AdminDashboard() {
  const [s, setS] = useState(null);

  useEffect(() => {
    api.get("/admin/analytics").then((r) => setS(r.data));
  }, []);

  if (!s) return <div className="p-10 text-white/40">Caricamento...</div>;

  const cards = [
    { l: "Visite totali", v: s.total_views, sub: `${s.views_7d} ultimi 7gg`, icon: Eye },
    { l: "Visite 30 giorni", v: s.views_30d, sub: "tracciate", icon: TrendingUp },
    { l: "Richieste contatto", v: s.total_contacts, sub: `${s.new_contacts} nuove`, icon: Mail },
    { l: "Recensioni", v: s.total_reviews, sub: `${s.pending_reviews} in attesa`, icon: Star },
  ];

  return (
    <div data-testid="admin-dashboard" className="p-10">
      <h1 className="font-serif text-4xl text-white mb-2">Dashboard</h1>
      <p className="text-white/50 text-sm mb-10">Panoramica generale dell'attività del sito.</p>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
        {cards.map((c, i) => (
          <div key={i} className="luxe-card p-6">
            <div className="flex justify-between items-start mb-4">
              <c.icon size={20} className="text-[var(--gold)]" />
              <span className="text-[0.6rem] uppercase tracking-widest text-white/30">{c.sub}</span>
            </div>
            <div className="font-serif text-4xl text-white">{c.v}</div>
            <div className="text-xs text-white/40 mt-1">{c.l}</div>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-3 gap-5">
        <div className="luxe-card p-6 lg:col-span-2">
          <h3 className="font-serif text-xl text-white mb-1">Visite ultimi 14 giorni</h3>
          <p className="text-xs text-white/40 mb-6">Visite per giorno</p>
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={s.daily_views}>
              <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" />
              <XAxis dataKey="date" stroke="rgba(255,255,255,0.4)" fontSize={11} />
              <YAxis stroke="rgba(255,255,255,0.4)" fontSize={11} />
              <Tooltip contentStyle={{ background: "#0a1628", border: "1px solid rgba(212,175,55,0.3)", borderRadius: 2 }} labelStyle={{ color: "#D4AF37" }} />
              <Bar dataKey="views" fill="#D4AF37" />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="luxe-card p-6">
          <h3 className="font-serif text-xl text-white mb-1">Pagine più viste</h3>
          <p className="text-xs text-white/40 mb-5">Top 10</p>
          <div className="space-y-3">
            {s.top_pages.map((p) => (
              <div key={p.page} className="flex justify-between items-center text-sm">
                <span className="text-white/70">/{p.page}</span>
                <span className="gold-text font-serif text-lg">{p.count}</span>
              </div>
            ))}
            {!s.top_pages.length && <div className="text-white/30 text-sm">Nessun dato ancora.</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
